// extracted by mini-css-extract-plugin
module.exports = {"page":"sign-in_page__1mki7","root":"sign-in_root__2UR5J","form":"sign-in_form__3WPRs","button":"sign-in_button__C4M6I","ob":"sign-in_ob__1sqtv"};